import React from 'react';
import LegalPage from '../../components/LegalPage';

const AgbPage: React.FC = () => (
  <LegalPage contentKey="page_agb" seoTitleKey="seo.agb_title" canonicalPath="/agb" />
);

export default AgbPage;
